// extracted by mini-css-extract-plugin
export default {"Loading":"bcx_a big_a big_w big_j big_ul big_um big_fm"};